// keepr's legal pages (KPR-259 privacy and terms; KPR-478 consumer health
// data): ONE switch for all of them, and the list the footer links.
//
// The wording is the owner's and counsel's. Drafts live outside the repo
// (~/Dropbox/KEEPR/docs/legal-drafts) and publish only once the Oregon LLC
// exists and a lawyer has reviewed them (ruling p06). Nothing of a draft is
// committed here: anything in src/ ships in the bundle every visitor
// downloads, so a draft committed "behind the switch" would already be
// published. Rejected: a build-time environment flag — publishing needs the
// reviewed text added in the same change anyway, so the switch belongs beside
// it, in review.
//
// TO PUBLISH: put each page's reviewed text in its module under
// src/content/legal/, add the other pages to LEGAL_PAGES (KPR-259: /privacy,
// /terms), and set LEGAL_PUBLISHED to true. Until then every page answers with
// a short "not published yet" notice and the footer links nothing.
//
// PUBLISHING THE HEALTH PAGE NEEDS A NEW CONSENT VERSION IN THE SAME RELEASE
// (keepr-api config/healthDataConsent.js): the consent step links this page,
// and the version a person agreed to must name one page, not "not published
// yet" for some and the policy for others.

import CONSUMER_HEALTH_DATA_POLICY from '../content/legal/consumerHealthData';

export const LEGAL_PUBLISHED = false;

/** Every legal page: where it lives, what the footer calls it, and its text (null until published). */
export const LEGAL_PAGES = Object.freeze([
	Object.freeze({
		key: 'consumer-health-data',
		path: '/consumer-health-data',
		label: 'Consumer health data',
		title: 'Consumer health data',
		markdown: CONSUMER_HEALTH_DATA_POLICY,
	}),
]);

/** Whether the legal pages are published. A function, so a test can say yes. */
export function legalPublished() {
	return LEGAL_PUBLISHED;
}

/** The page `key` — its text only when published and present, else `markdown: null`. */
export function legalPage(key) {
	const page = LEGAL_PAGES.find(p => p.key === key) || null;
	if (!page) return null;
	const text = legalPublished() && typeof page.markdown === 'string' && page.markdown.trim() ? page.markdown : null;
	return { ...page, markdown: text };
}

/** What the footer links: the published pages, or nothing while unpublished. */
export function footerLegalLinks() {
	return LEGAL_PAGES.map(p => legalPage(p.key)).filter(p => p && p.markdown);
}
